import {ga} from 'shared'

function debounce(callback, wait, immediate = false) {
  let timeout = null

  return function () {
    const callNow = immediate && !timeout
    const next = () => callback.apply(this, arguments)

    clearTimeout(timeout)
    timeout = setTimeout(next, wait)

    if (callNow) {
      next()
    }
  }
}

// If 24% threshold is passed, the first event should occur
let maxScrollPercentage = 24

export const gaScrollTracking = debounce(() => {
  const html             = document.documentElement
  const body             = document.body
  const pageHeight       = Math.max(html.offsetHeight, html.scrollHeight, body.offsetHeight, body.scrollHeight)
  const scrollPos        = window.pageYOffset
  const windowHeight     = window.innerHeight
  const scrollPercentage = Math.min(100, Math.max(0, Math.round(100 * (scrollPos / (pageHeight - windowHeight)))))

  if (maxScrollPercentage < scrollPercentage) {
    let newValue = scrollPercentage
    if (scrollPercentage >= 25 && scrollPercentage < 50) {
      newValue = 25
    } else if (scrollPercentage >= 50 && scrollPercentage < 75) {
      newValue = 50
    } else if (scrollPercentage >= 75 && scrollPercentage < 90) {
      newValue = 75
    } else if (scrollPercentage >= 90 && scrollPercentage < 100) {
      newValue = 90
    } else if (scrollPercentage >= 100) {
      newValue = 100
    }

    if (newValue > maxScrollPercentage) {
      maxScrollPercentage = newValue
      ga('send', 'event', 'scroll depth', maxScrollPercentage, gaTrackingPath, {nonInteraction: true})
    }
  }
}, 100, true)
